import React from "react"
import { useParams } from "react-router-dom"
import style from "./Bar.module.scss"
import { bars } from "../data/bars"
import cn from "classnames"
import { getAverageStar, getBarBadges } from "../service/barMethods"
import { BadgeList } from "./BadgeList"
import { MapContainer, Marker, Popup, TileLayer, Tooltip } from "react-leaflet"
import { barIcon_star } from "../data/icons"
import { Stars } from "./Stars"

export const BarComponent: React.FC = () => {
  const params = useParams()
  const bar = bars.find((bar) => bar.id === params.id)
  if (!bar || !bar.info)
    return <span className="errorPage">Такой страницы не существует :(</span>

  const getStarColor = (value: number) => {
    if ([1, 2].includes(value)) return style.bad
    if ([3].includes(value)) return style.normal
    if ([4].includes(value)) return style.good
    if ([5].includes(value)) return style.great
  }

  const barBadges = getBarBadges(bar)

  return (
    <>
      <div className={style.barPage}>
        <div className={style.black}>
          <div className={style.title}>
            <h2>{bar.title}</h2>
            <p>{bar.address}</p>
          </div>
          <br />
          <BadgeList badgeList={barBadges} />
          <br />
          <div className={style.ratings}>
            <table border={0} className={style.ratingsTable}>
              {Object.entries(bar.info.ratings).map(([key, value]) => (
                <tr>
                  <td>{key}</td>
                  <td>
                    <Stars starsCount={value} />
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <span>
                    <strong>Средняя оценка</strong>
                  </span>
                </td>
                <td>
                  <span
                    className={cn(
                      getStarColor(getAverageStar(bar)),
                      style.stars
                    )}
                  >
                    <Stars starsCount={getAverageStar(bar)} />
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <br />
          <br />
          <div className={style.review}>
            {bar.info.review.map((line) => (
              <div className={style.reviewLine}>{line}</div>
            ))}
          </div>

          <div className={style.map}>
            <MapContainer
              center={bar.latlng}
              zoom={15}
              scrollWheelZoom={true}
              style={{ height: "100%", width: "80vw" }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker icon={barIcon_star} position={bar.latlng}>
                <Popup>{bar.address}</Popup>
                <Tooltip
                  direction="bottom"
                  offset={[0, 5]}
                  opacity={1}
                  permanent
                  className={style.popup}
                >
                  {bar.title}
                </Tooltip>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </>
  )
}
